import React from "react";
import { Button, Conditional, Else, Heading, If, jsxJoin, List, Modal, useToggle } from "@hex-insights/core";
import {
	Permission,
	PermissionGroupLink,
	UserLink,
	useUsersWithPermissionLazyQuery,
} from "@hex-insights/roadium.shared";

export type UsersWithPermissionProps = {
	id: Permission["id"];
};

export function UsersWithPermission({ id }: UsersWithPermissionProps) {
	const { isOn: isOpen, toggle: toggleIsOpen } = useToggle(false);
	const [load, { loading, data, error }] = useUsersWithPermissionLazyQuery({ variables: { id } });

	React.useEffect(() => {
		if (isOpen) {
			load();
		}
	}, [isOpen, load]);

	const users = data?.userConnection;

	return (
		<React.Fragment>
			<Button variant="tertiary" onClick={toggleIsOpen}>
				View Users with This Permission
			</Button>

			<Modal.If condition={isOpen}>
				<Modal onClose={toggleIsOpen}>
					<Modal.Header>
						<Heading level={2} noMargin>
							Active Users
						</Heading>
					</Modal.Header>

					<Modal.Body>
						<Conditional>
							<If condition={loading}>Loading...</If>
							<If condition={error !== undefined}>Error loading users</If>
							<Else>
								{!!users && (
									<List>
										{users.edges.map((e) => (
											<List.Item key={e.node.id} style={{ marginBottom: "0.75rem" }}>
												<UserLink instance={e.node} />
												<div style={{ margin: "0.25rem 0 0 0.25rem", fontSize: "0.9rem" }}>
													Through:{" "}
													{jsxJoin(
														e.node.permissionGroups.map((pg) => <PermissionGroupLink key={pg.id} instance={pg} />),
														", ",
													)}
												</div>
											</List.Item>
										))}
									</List>
								)}
							</Else>
						</Conditional>
					</Modal.Body>
				</Modal>
			</Modal.If>
		</React.Fragment>
	);
}
